import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { withRouter } from 'react-router';
import segment from 'segment';

import './index.css';
import { Box } from 'src/lib/StyledComponents';
import asyncComponent from 'src/utils/asyncComponent';
import Landing from 'src/ConnectedComponents/Landing';
import Signup from 'src/ConnectedComponents/Signup';
import Login from 'src/ConnectedComponents/Login';
import ForgotPassword from 'src/ConnectedComponents/ForgotPassword';
import ConfirmUser from 'src/ConnectedComponents/ConfirmUser';
import Setup from 'src/ConnectedComponents/Setup';
import BlackbaudAuthCallback from 'src/ConnectedComponents/Setup/BlackbaudAuthCallback';
import { withScrollToTop } from 'src/utils/withScrollToTop';

window.toast = toast;
const Dashboard = asyncComponent(() => import('../Dashboard'));
const WrappedLanding = withScrollToTop(Landing);
const WrappedSignup = withScrollToTop(Signup);
const WrappedLogin = withScrollToTop(Login);
const WrappedForgotPassword = withScrollToTop(ForgotPassword);
const WrappedConfirmUser = withScrollToTop(ConfirmUser);
const WrappedSetup = withScrollToTop(Setup);

@withRouter
class App extends Component {
	componentDidMount() {
		const { location } = this.props;
		segment.page(location.pathname, location.search);
	}

	componentWillReceiveProps(nextProps) {
		if (
			this.props.location.pathname !== nextProps.location.pathname ||
			this.props.location.search !== nextProps.location.search
		) {
			segment.page(nextProps.location.pathname, nextProps.location.search);
		}
	}

	render() {
		return (
			<Box>
				<ToastContainer position="top-right" autoClose={5000} />
				<Switch>
					<Route exact path="/" component={WrappedLanding} />
					<Route path="/dashboard" component={Dashboard} />
					<Route path="/signup" component={WrappedSignup} />
					<Route path="/login" component={WrappedLogin} />
					<Route path="/password_reset" component={WrappedForgotPassword} />
					<Route path="/confirm" component={WrappedConfirmUser} />
					<Route path="/setup" component={WrappedSetup} />
					<Route path="/blackbaud_auth_callback" component={BlackbaudAuthCallback} />
				</Switch>
			</Box>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/App/index.js